<template>
  <div>
    <v-card class="hvh-card--rounded hvh-card--teal">
      <div class="pa-3" @click="handleClick" v-right-click-menu="`/Analytics/Cohort/${cohortData.id}/Overview`">
        <div>
          <div class="hvh-flex space-between align-center">
            <h2 class="hvh-cohort-title mr-3">
              <span>{{ cohortData.title }}</span>
              <span>
                <v-chip class="hvh-chip--white">{{ cohortData.patientCount.toLocaleString('default') }} patients
                </v-chip>
              </span>
            </h2>
          </div>
          <div class="hvh-cohort-description" v-if="cohortData.description">
            <p class="my-0">{{ cohortData.description }}</p>
          </div>
          <div :class="{ 'mt-2': cohortData.description }" v-if="(cohortData.tags || []).length">
            <p class="my-0">{{ cohortData.tags.map((f) => `${f.startsWith('#') ? f : '#' + f}`).join(' ') }}</p>
          </div>
          <dl class="hvh-cohort-meta mt-3">
            <div>
              <dt>Created:</dt>
              <dd>{{ dateFormatter(cohortData.createdDate) }}</dd>
            </div>
            <div>
              <dt>Last Updated:</dt>
              <dd>{{ dateFormatter(cohortData.lastUpdatedDate) }}</dd>
            </div>
            <div>
              <dt>Creator:</dt>
              <dd>{{ cohortData.creator }}</dd>
            </div>
          </dl>
        </div>
      </div>
      <hvh-cohort-analyses-table :tableData="tableData" :dateFormatter="dateFormatter" :analyticColors="analyticColors"
        :expanded="expanded" @table-row-click="handleTableRowClick($event)">
        <template v-slot:expansion-heading>
          <slot name="expansion-heading" />
        </template>
      </hvh-cohort-analyses-table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['tableData', 'cohortData', 'expanded', 'dateFormatter', 'analyticColors'],
  methods: {
    handleClick() {
      this.$emit('card-title-click');
    },
    handleTableRowClick(props) {
      this.$emit('table-row-click', props);
    },
  }
}
</script>

<style lang="scss" scoped>
.hvh-chip--white {
  background: $color-white;
  color: $color-teal;
}

.hvh-card-title {
  cursor: pointer;
}

.hvh-cohort-title {
  font-size: rem(32px);
  font-weight: bold;
  letter-spacing: 0.2px;
  display: flex;
  white-space: nowrap;

  >span {
    display: flex;
    align-items: center;
  }

  .v-chip {
    margin-left: 15px;
  }
}

.hvh-cohort-description {
  font-size: rem(16px);
  line-height: 1.5;
  width: 500px;
}

.hvh-cohort-meta {
  display: flex;

  div {
    display: flex;

    &::after {
      content: '|';
      padding: 0 1rem;
    }

    &:last-child::after {
      content: '';
    }
  }

  dt {
    font-weight: bold;
    margin-right: 0.5rem;
  }
}
</style>